import { useEffect, useState } from "react";
import { API_URL } from "env";
import ProductList, { Product } from "./ProductsList";
import { fetchRelatedProducts } from "api/ProductDetail";


interface ListProductByCateProps {
    categoryId?: number;
    currentProductId?: number;
}

export default function ListProductByCate({ categoryId, currentProductId }: ListProductByCateProps) {
    const [relatedProducts, setRelatedProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    console.log(currentProductId);

    useEffect(() => {
        if (!categoryId) {
            setLoading(false);
            return;
        }

        const loadData = async () => {
            setLoading(true);

            // 1. Gọi API lấy dữ liệu thô
            const result = await fetchRelatedProducts(categoryId);

            if (result?.data?.items) {
                // 2. Lọc bỏ sản phẩm hiện tại
                const filteredItems = result.data.items.filter(
                    (item: any) => item.id !== currentProductId
                );

                // 3. Cắt mảng, chỉ lấy tối đa 5 sản phẩm
                const limitedItems = filteredItems.slice(0, 5);

                // 4. Map dữ liệu thô sang Interface Product của UI
                const mapped: Product[] = limitedItems.map((item: any) => {
                    let discountPercent = item.discount || 0;

                    // Tính % giảm giá từ Flash sale nếu có
                    if (!discountPercent && item.promotion_flash_sale_product?.length > 0) {
                        const maxPercent = Math.max(...item.promotion_flash_sale_product.map((p: any) => p.percent || 0));
                        if (maxPercent > 0) discountPercent = maxPercent;
                    }

                    const hasDiscount = discountPercent > 0;
                    const finalPrice = hasDiscount
                        ? Math.round(item.price * (1 - discountPercent / 100))
                        : item.price;

                    return {
                        id: item.id,
                        name: item.name,
                        unit: item.short_content || "Hộp",
                        image: item.avatar ? (item.avatar.startsWith('http') ? item.avatar : `${API_URL.replace(/\/$/, '')}/${item.avatar}`) : "",
                        price: finalPrice,
                        promoPrice: hasDiscount ? item.price : undefined,
                        discount: hasDiscount ? `-${discountPercent}%` : undefined,
                        sold: 0,
                        seller: item.product_category?.name || "Dược Tâm An",
                        sellerLogo: "https://cdn-web-next.thuocsi.vn/icons/color_seller.svg",
                        quantity: 0,
                        liked: item.is_follow === 1,
                        bg: false,
                        slug: item.slug
                    };
                });

                setRelatedProducts(mapped);
            }
            setLoading(false);
        };

        loadData();
    }, [categoryId, currentProductId]);

    if (loading) {
        return <div className="p-4 text-center text-gray-500">Đang tải sản phẩm liên quan...</div>;
    }

    if (relatedProducts.length === 0) {
        return null;
    }

    return (
        <ProductList data={relatedProducts} />
    );
}